module.exports = "../static/images/d5c1ab.png";